<div>
  <span class="title">Revoke Access</span>
  <div class="mt-3 row mx-0" style="font-size: 14px;">
    <div [formGroup]="revokeAccessForm" class="col-9 p-0">
      <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">SSO
        <span style="color: red;">*</span>
      </div>
      <div class="col-12 p-0 row m-0">
        <div class="col-6 p-0">
          <mat-form-field floatLabel="never" appearance="outline" class="col-11 p-0">
            <input formControlName="sso" name="sso" matInput placeholder="" style="color: #18181a;">
            <mat-hint align="end">{{revokeAccessForm.controls.sso.value.length || 0}} / 50</mat-hint>
            <mat-error>{{revokeAccessForm.controls.sso.errors?.message}}</mat-error>
          </mat-form-field>
        </div>
        <div class="col-6 p-0 d-flex justify-content-center align-items-center">
          <button class="btn btn-primary button" (click)="search()"
            style="height: 50px; margin-top: -9px; width: 100px;">Search</button>
        </div>
      </div>
      <div class="row m-0">
        <div class="col-xl-6 col-md-6 col-sm-6 p-0">
          <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3">Full Name
          </div>
          <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 disabled-input">
            <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
              <input formControlName="fullName" name="fullName" matInput readonly>
            </mat-form-field>
          </div>
        </div>
        <div class="col-xl-6 col-md-6 col-sm-6 p-0">
          <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto">Email
          </div>
          <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
            <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
              <input formControlName="email" name="email" matInput readonly>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-6 d-flex flex-column p-0">
        <span>Revoke Access to app</span>
        <mat-form-field appearance="outline" class="col-11 p-0">
          <mat-label></mat-label>
          <mat-select formControlName="appName" (openedChange)="getStatus($event)" multiple>
            <mat-option *ngFor="let app of apps" [value]="app.value">
              {{app.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 column p-0">
        <span>Reason for revocation</span>
        <mat-form-field appearance="outline" class="w-100">
          <textarea matInput formControlName="reason" [maxlength]="512" style="height: 100px;"></textarea>
          <mat-hint align="end">{{revokeAccessForm.controls.reason.value.length || 0}} / 512</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 p-0">
        <button class="btn button btn-primary btn-save" (click)="revokeAccess()" style="width: 127px">Revoke Access</button>
      </div>
    </div>
    <div class="col-3 pt-3">
      <div class="d-flex justify-content-between">
        <span class="title-request">Request created</span>
        <div id="refresh" class="header-links ml-auto" style="padding-right: 2px;">
          <i class="fa fa-refresh" style="cursor: pointer; color: #005E60;"
          (click)="reloadStatus($event)"></i>
        </div>
      </div>
      <hr color="#e8e8e8" class="m-1">
      <mat-card *ngFor="let item of listStatus" class="mt-3">
        <div class="d-flex flex-column">
          <div>
            <span class="font-weight-bold">Request submit at:</span>
            <span class="pl-2" style="font-style: italic;">{{item.date}}</span>
          </div>
          <div>
            <span class="font-weight-bold">Request ID number:</span>
            <span class="pl-2" style="font-style: italic;">{{item.number}}</span>
          </div>
          <div>
            <span class="font-weight-bold">Status:</span>
            <span class="pl-2" style="font-style: italic;">{{item.status}}</span>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>